<template>
  <div class="app-subscribe_asu" :class="{ [this.curTheme]: true }">
    <el-tooltip
      :hide-after="2000"
      content="Информирование о новых ЦОАП"
      placement="top">
      <button
        class="asu_btn"
        @click="initSubscribe"
        :class="{ 'asu_btn--subscribed': isSubscribed }"
        v-if="isVisible">
        <i class="el-icon-message"></i>
        <span class="asu_state"><i class="el-icon-check"></i></span>
      </button>
    </el-tooltip>

    <transition name="popup-fade">
      <div class="adv-popup_app" v-if="winIsOn">

        <div class="app_header">
          Информирование о новых ЦОАП
          <button @click="winIsOn = false" class="app_close">
            <i class="el-icon-close"></i></button>
        </div>

        <div class="app_body">
          <div class="app_first-line">Вы собиратесь подписаться на
            информирование о появлении новых ЦОАП, удовлетворяющих
            выбранным вами в данный момент критериям поиска:</div>
          <ul
            v-if="Object.keys(filtersDisplay[0]).length > 0"
            class="app_ul">
            <template
              v-for="(val, id, i) in filtersDisplay[0]">
              <li
                v-if="id === 'dateStart'"
                :key="`filter-${i}`">
                <span class="app_color-grey">Дата депонирования:</span>
                с {{ filtersDisplay[0]['dateStart'] }} по {{ filtersDisplay[0]['dateEnd'] }}
              </li>
              <li
                v-else-if="id !== 'dateEnd'"
                :key="`filter-${i}`">
                <span class="app_color-grey">{{ searchFilters[id].title }}:</span> {{ val }}
              </li>
            </template>
          </ul>

          <p class="app_notice">
            На ваш e-mail будут приходить письма о появлении на платформе IPUniversity
            новых ЦОАП. Список подписок отображается в вашем личном кабинете в
            разделе «Мои подписки». Там же Вы можете отказаться от подписки.
          </p>
        </div>

        <div class="app_btns">
          <button @click="submitSubscribe" class="app_btn app_btn--message">
            <i class="el-icon-message"></i> Подписаться</button>
        </div>

      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import SearchFilters from '../mixins/SearchFilters';

export default {

  mixins: [SearchFilters],

  data() {
    return {
      isVisible: false,
      isSubscribed: false,
      winIsOn: false,
      filtersChosenIds: {},
      filtersChosenRaw: {},
    };
  },

  created() {
    this.init();
  },

  computed: {

    userId() {
      return this.$store.getters['user/getUserId'];
    },

  },

  methods: {

    init() {
      if (!this.userId) return;
      this.isSubscribed = false;
      const queryKeys = Object.keys(this.$route.query);
      const filtersKeys = Object.keys(this.searchFilters);
      for (let i = 0; i < queryKeys.length; i += 1) {
        const key = queryKeys[i];
        if (filtersKeys.indexOf(key) > -1
          && typeof this.$route.query[key] !== 'undefined'
          && this.$route.query[key] !== ''
        ) {
          this.isVisible = true;
          break;
        }
      }
      // Check subscribed
      if (this.isVisible) {
        this.collectFilters();
        const params = this.filtersChosenRaw;
        axios.get('subscribe/my/check', { params }).then((r) => {
          this.isSubscribed = (r.data === 'true');
        });
      }
    },

    collectFilters() {
      const query = this.$route.query;
      const filtersIds = Object.keys(this.searchFilters);
      Object.keys(query).forEach((key) => {
        if (filtersIds.indexOf(key) > -1) {
          this.filtersChosenRaw[key] = query[key];
          this.filtersHandler(0, key, query[key]);
        }
      });
    },

    initSubscribe() {
      if (this.isSubscribed) {
        this.$alert('Вы уже подписаны на рассылку о появлении новых ЦОАП, соответствующих этому профилю поиска.');
      } else {
        this.collectFilters();
        this.winIsOn = true;
      }
    },

    submitSubscribe() {
      let message = '';
      Vue.$loading.on();
      axios.post('subscribe/add', this.filtersChosenRaw).then((r) => {
        message = r.data;
        this.$message.closeAll();
        this.isSubscribed = true;
      }).catch((err) => {
        message = err.response.data;
      }).finally(() => {
        this.winIsOn = false;
        setTimeout(() => {
          Vue.$loading.off();
        }, 400);
        setTimeout(() => {
          this.$alert(message);
        }, 600);
      });
    },

  },

};
</script>

<style lang="scss">
@import '../styles/common/main';

.app-subscribe_asu {
  display: inline-block;
  width: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  top: 0;
  .asu_btn {
    display: block;
    color: #bbb;
    width: 50px;
    height: 50px;
    padding: 4px 0 0;
    text-align: center;
    border: 1px solid rgba(125, 125, 125, .4);
    @include border-radius(50%);
    cursor: pointer;
    position: relative;
    &.asu_btn--subscribed {
      .asu_state {
        position: absolute;
        z-index: 5;
        top: -2px;
        right: -2px;
        display: block;
        background: #747474;
        @include border-radius(50%);
        width: 16px;
        height: 16px;
        color: #fff;
        i {
          position: relative;
          top: -2px;
          right: 0;
          font-size: 10px;
        }
      }
    }
    .asu_state {
      display: none;
    }
    .el-icon-message {
      display: inline-block;
      font-size: 16px;
    }
  }
  @media (max-width: 750px) {
    left: 110px;
  }
  @media (max-width: 450px) {
    left: 105px;
  }

  .adv-popup_app {
    background: #fff;
    position: absolute;
    max-width: 700px;
    left: 50%;
    margin-left: -350px;
    @include border-radius(12px);
    padding: 0 30px;
    overflow: hidden;
    z-index: 10;
    @include box-shadow(0 2px 20px rgba(0, 0, 0, .2));
    @media (max-width: 750px) {
      margin: 0;
      left: 15px;
      right: 15px;
    }
    .app_header {
      margin: 0 -30px 0;
      padding: 35px 65px 25px 25px;
      text-align: left;
      text-transform: uppercase;
      font-weight: 400;
      position: relative;
      color: lighten($color-1, 5%);
      .app_close {
        position: absolute;
        right: 20px;
        top: 16px;
        color: #000;
        font-size: 28px;
        opacity: .5;
        @include transition;
        cursor: pointer;
        &:hover {
          opacity: 1;
        }
      }
      @media (max-width: 800px) {
        text-align: left;
      }
    }
    .app_btns {
      margin: 0 -30px;
      text-align: center;
      padding: 10px 0 30px;
      .app_btn {
        margin: 10px;
        width: 150px;
        display: inline-block;
        text-align: center;
        @include border-radius;
        cursor: pointer;
        line-height: 0;
        font-weight: 300;
        color: #333;
        font-size: 15px;
        border: 1px solid #bbb;
        padding: 10px 0;
        @include transition;
        &:hover {
          color: #fff;
          background: #bbb;
          border-color: transparent !important;
        }
        &.app_btn--message {
          border-color: #da5486;
          color: #da5486;
          font-weight: 400;
          &:hover {
            color: #fff;
            @extend .grad;
          }
          i {
            margin-right: 6px;
          }
        }
      }
    }
    .app_body {
      color: #000;
    }
    .app_first-line {
      margin-bottom: 15px;
      font-weight: bold;
      font-size: 17px;
    }
    .app_ul {
      padding-left: 30px;
    }
    .app_color-grey {
      color: #999;
    }
    .app_notice {}
  }

  &.theme-w {
    .asu_btn {
      &.asu_btn--subscribed {
        .asu_state {
          color: #fff;
          background: #c0c0c0;
        }
      }
    }
  }

  .popup-fade-enter-active, .popup-fade-leave-active {
    transition: all .5s;
    @include transform(translateY(0));
  }
  .popup-fade-enter, .popup-fade-leave-to {
    opacity: 0;
    @include transform(translateY(-30px));
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppSubscribe.vue